import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import { StatusLabel } from '../StatusLabel';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export const ClosedStatusLabel: React.FC = () => {
    const { t } = useLanguageLocale();

    return (
        <StatusLabel
            status={t('DASHBOARD.TIMELINE_DETAILS.CLOSED')}
            foregroundColor={PXBColors.white[50]}
            backgroundColor={PXBColors.gray[200]}
            testId="closed-status-label"
        />
    );
};
